export const NAV_LINKS = [
  { label: "Now Playing", href: "#current" },
  { label: "Showreel", href: "#work" },
  { label: "Services", href: "#services" },
  { label: "Clients", href: "#clients" },
  { label: "Studio", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export const CURRENT_WORK = [
  {
    id: "apna-superstar",
    title: "Apna Superstar",
    client: "Tata Motors Commercial Vehicles",
    format: "Bullet Micro Drama · Originals",
    language: "Hindi",
    status: "Live on Bullet",
    poster: "/project-apna-superstar.jpg",
    secondaryPoster: "/project-apna-superstar-2.jpg",
    blurb:
      "A heart-warming micro-drama for Tata Motors' 'Better Always' platform — written, produced and delivered end-to-end by our production arm for the Bullet app.",
  },
];

export const CLIENTS = [
  { name: "Glenmark", logo: "/clients/glenmark.png" },
  { name: "Sherry", logo: "/clients/sherry.jpeg" },
  { name: "Emami", logo: "/clients/emami.png" },
  { name: "Royal Enfield", logo: "/clients/royal-enfield.png" },
  { name: "Livpure", logo: "/clients/livpure.png" },
  { name: "MHT", logo: "/clients/mht.png" },
  { name: "Ctrl H", logo: "/clients/ctrl-h.png" },
  { name: "Cipla", logo: "/clients/cipla.png" },
  { name: "Star Sports", logo: "/clients/star-sports.png" },
  { name: "Project Mumbai", logo: "/clients/project-mumbai.png" },
  { name: "Barry Callebaut", logo: "/clients/barry-callebaut.jpg" },
  { name: "Bullet", logo: "/clients/bullet.png" },
  { name: "Spykar", logo: "/clients/spykar.png" },
  { name: "Tata Sampann", logo: "/clients/tata-sampann.png" },
  { name: "Tata Communications", logo: "/clients/tata-communications.png" },
  { name: "Zandu", logo: "/clients/zandu.jpeg" },
  { name: "WFP", logo: "/clients/wfp.png" },
  { name: "Warner Bros", logo: "/clients/warner-bros.png" },
  { name: "Tata", logo: "/clients/tata.jpg" },
  { name: "Better Seasons", logo: "/clients/better-seasons.png" },
  { name: "SBI Mutual Fund", logo: "/clients/sbi.png" },
  { name: "ZEE5", logo: "/clients/zee5.png" },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Order from chaos",
    body: "We live at sixes and sevens on purpose. Brands are born in the mess — half-formed ideas, contradictions, tension. Our job is to find the signal in the noise and make it unmistakable.",
  },
  {
    n: "02",
    title: "Strategy before spectacle",
    body: "Beautiful work that says nothing is decoration. Every frame, headline and pixel we ship is anchored to a strategy sharp enough to change behaviour, not just win applause.",
  },
  {
    n: "03",
    title: "One studio, end to end",
    body: "From the first positioning workshop to the final colour grade, it never leaves the building. Brand and production under one roof means nothing gets lost in translation.",
  },
];

export const SERVICES = [
  {
    group: "Brand Building",
    tag: "Ideas that scale",
    items: [
      { name: "Brand Strategy", desc: "Positioning, architecture & narrative that give the brand a spine." },
      { name: "Identity & Ideation", desc: "Naming, visual systems and the big idea everything hangs from." },
      { name: "Social Media", desc: "Always-on content, community and campaigns built for the feed." },
      { name: "Content Creation", desc: "Photography, design and copy that keep the brand alive daily." },
    ],
  },
  {
    group: "Content Creation",
    tag: "Stories in motion",
    items: [
      { name: "Television Commercials", desc: "Broadcast-grade TVCs from board to master, end to end." },
      { name: "Digital Films", desc: "Cinematic brand films made for screens of every size." },
      { name: "Animation & AI Films", desc: "2D, 3D, motion design and AI-driven films that move people and product." },
      { name: "Micro Fiction & Web Series", desc: "Episodic, bingeable formats and short fiction that build audiences over time." },
    ],
  },
];

export const MARQUEE = [
  "Brand Strategy",
  "TV Commercials",
  "Digital Films",
  "Animation",
  "Web Series",
  "Social",
  "Ideation",
];

export const WORK = [
  {
    id: "animation",
    title: "Animation & AI Films",
    cat: "Motion · AI · Web Series",
    year: "Reel",
    span: "lg:col-span-6",
    href: "https://vimeo.com/user164494980",
    img: "/work-animation.webp",
  },
  {
    id: "film",
    title: "Films & Commercials",
    cat: "TVCs · Digital Films",
    year: "Reel",
    span: "lg:col-span-6",
    href: "https://vimeo.com/sanjaysantwan",
    img: "https://images.unsplash.com/photo-1632187989763-c9c620420b4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxmaWxtJTIwcHJvZHVjdGlvbiUyMHNldHxlbnwwfHx8fDE3ODUxNTIzMjV8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const STATS = [
  { value: "50+", label: "Films Created" },
  { value: "4", label: "Years in the Biz" },
  { value: "20+", label: "Brands Shaped" },
];
